import classnames from 'classnames'
import React, {ChangeEvent, useCallback, useRef} from 'react'
import { Field } from 'react-final-form'
import { useIntl } from 'react-intl'

import styles from './Checkbox.module.css'
import {FieldValidator} from "final-form";

interface ICheckboxProps {
  label?: string | React.ComponentElement<any, any>,
  name: string
  placeholder?: string
  optional?: boolean
  forceUppercase?: boolean
  ariaDescription?: string
  type?: 'date' | 'text' | 'number',
  disabled?: boolean,
  validate?: FieldValidator<string>
}

const parseAsUpperCased = (val: string) => val.toUpperCase()

export const Checkbox: React.FC<ICheckboxProps> = ({
  name,
  label,
  placeholder,
  optional,
  forceUppercase,
  ariaDescription,
  validate = undefined,
}) => {
  const requiredValidation = useCallback((value: string) => {
    if (!optional && (value == null || value === '')) {
      return 'Required field'
    }

    return undefined
  }, [optional])

  const validatorRef = useRef<FieldValidator<string>>((value: string, allValues: any) => {
    const validations: Array<FieldValidator<string>> = []

    if (!optional) {
      validations.push(requiredValidation)
    }
    if (validate != null) {
      validations.push(validate)
    }

    return validations.reduce((message: string | undefined, fn) => (
        message == null
            ? fn(value, allValues)
            : message
    ), undefined)
  })

  return (
    <Field
      name={name}
      parse={forceUppercase ? parseAsUpperCased : undefined}
      validate={validatorRef.current}
      type='checkbox'
    >
      {({ input, meta }) => (
        <div className={styles.Checkbox}>
          <input
            className={classnames({ 'custom-control custom-checkbox': true, 'is-invalid': meta.touched && meta.error })}
            type='checkbox'
            {...input}
            placeholder={placeholder}
            aria-describedby={ariaDescription}
            checked={input.checked}
            required={optional ? '' : 'required' as any}
            onChange={event => {
              (event.target as HTMLInputElement).setCustomValidity("");
              input.onChange(event);
            }}
            onInvalid={event => (event.target as HTMLSelectElement).setCustomValidity('Obavezno polje.')}
          />
          { label && <label htmlFor={name}>{label}</label> }
          { ariaDescription && (
            <span
              id={`help-${name}`}
              className={classnames('form-text text-muted', styles.AriaDescription)}
            >
              { ariaDescription }
            </span>
          ) }
        </div>
      )}
    </Field>
  )
}

